// extracted by mini-css-extract-plugin
export default {"viewport":"styles_viewport__pRpoK","premiumReport":"styles_premiumReport__fYlMR","viewportInner":"styles_viewportInner__nrvR8"};